import { Injectable } from '@angular/core';

import { of, switchMap, catchError, Observable } from 'rxjs';

import { Credentials } from '../types';
import { loginErrorAlerts } from '../constants';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';
import { AuthService } from '@tablesready/frontend-auth';
import { AuthUser } from '@shared/signup/models';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(
    private readonly authService: AuthService,
    private readonly alertService: AlertsService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {
  }

  login(credentials: Credentials): Observable<AuthUser> {
    return this.authService.login(credentials)
      .pipe(
        switchMap(() => this.authRestaurantService.load()),
        switchMap(() => this.authRestaurantService.buildOnce()),
        catchError((error: string) => {
          const alertOptions = {
            type: IAlertTypes.danger,
            ...(loginErrorAlerts[error] || loginErrorAlerts.default),
          };

          this.alertService.add(alertOptions);

          return of(null);
        }),
      );
  }
}
